import { contacto } from '../data/viajes';

/**
 * Link de WhatsApp con el mensaje ya escrito.
 * @param {string} texto
 * @returns {string}
 */
export const wa = (texto) => `https://wa.me/${contacto.wa}?text=${encodeURIComponent(texto)}`;

/** CTA general de todo el sitio. @type {string} */
export const WA_GENERAL = wa('Hola Jenny, quiero planear un viaje. ¿Me ayudas?');
/** CTA de la sección de preguntas frecuentes. @type {string} */
export const WA_DUDA = wa('Hola Jenny, tengo una duda sobre mi viaje:');
/** CTA de "Experiencias Disney" en Tours. @type {string} */
export const WA_DISNEY = wa('Hola Jenny, quiero cotizar un viaje a Disney. ¿Me ayudas?');

/**
 * @typedef {Object} Limite
 * @property {number} min
 * @property {number} max
 * @property {number} inicial
 */

/** Rango de viajeros del armador de mensaje. @type {{ adultos: Limite, ninos: Limite }} */
export const LIMITE_VIAJEROS = {
  adultos: { min: 1, max: 20, inicial: 2 },
  ninos: { min: 0, max: 20, inicial: 0 }
};

/**
 * Ajusta un contador al rango permitido.
 * @param {number} valor
 * @param {Limite} limite
 * @returns {number}
 */
export const ajustarViajeros = (valor, limite) => Math.min(limite.max, Math.max(limite.min, valor));

/**
 * @typedef {Object} SolicitudViaje
 * @property {string} tipo     uno de tiposViaje (src/data/contenido.js)
 * @property {number} adultos
 * @property {number} ninos
 * @property {string} fecha    texto libre; puede ir vacío
 * @property {string} nombre   puede ir vacío
 */

/**
 * Mensaje de la tarjeta "Arma tu mensaje" de Contacto:
 * "Hola Jenny[, soy {nombre}]. Quiero planear un viaje a {destino} para {N adultos}[ y {N niños}][, aproximadamente en {fecha}]. ¿Me ayudas?"
 * @param {SolicitudViaje} solicitud
 * @returns {string}
 */
export function armarMensajeViaje({ tipo, adultos, ninos, fecha, nombre }) {
  const destino = tipo === 'Otro destino' ? 'un destino que te quiero platicar' : tipo === 'Crucero' ? 'un crucero' : tipo;
  const quien = `${adultos} ${adultos === 1 ? 'adulto' : 'adultos'}${ninos ? ` y ${ninos} ${ninos === 1 ? 'niño' : 'niños'}` : ''}`;
  const n = nombre.trim();
  const f = fecha.trim();
  return `Hola Jenny${n ? `, soy ${n}` : ''}. Quiero planear un viaje a ${destino} para ${quien}${f ? `, aproximadamente en ${f}` : ''}. ¿Me ayudas?`;
}
